import { operatorClient, reportingClient, authClient } from 'domain/HttpClients';
import { namespace } from 'domain/operations/drivers/constants';

export const printDriverReport = async (filters, email) => {
  try {
    const response = await reportingClient
      .Get('api/resources/drivers')
      .withParams({
        emails: email,
        ...filters,
      })
      .send();
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getDriverInfoByPhoneNumber = async (phone) => {
  try {
    const response = await operatorClient
      .Get('/api/drivers')
      .withParams({ phone })
      .send();
    return response.results[0];
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const getBaseCities = async () => {
  try {
    const response = await operatorClient.Get('/api/vehicles/base-cities').send();
    return response.filter((item) => item);
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const getDriverInfoByProfileId = async (pid) => {
  try {
    const response = await operatorClient
      .Get('/api/drivers')
      .withParams({ pid })
      .send();
    return response.results[0];
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const assignReferenceIdToDriver = async (driverId, referenceId, token) => {
  const response = await operatorClient
    .Put('/api/users')
    .withData({
      profileId: driverId,
      refId: referenceId,
    })
    .send();
  return response;
};

export const addTag = async (tag, accountId, vehicleId, currentTags = []) => {
  try {
    const response = await operatorClient
      .Patch('/api/fleets/management/resource-tags')
      .withData({
        accountId,
        tags: [...currentTags, tag],
        vehicleIds: [vehicleId],
      })
      .send();
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};
export const setAvailability = async (id, state) => {
  try {
    const response = await operatorClient
      .Patch(`/api/drivers/${id}/availability`)
      .withParams({
        available: state,
      })
      .send();
    return response;
  } catch (e) {
    console.error(e);
    return false;
  }
};
export const getDriversByName = async (key) => {
  try {
    const response = await operatorClient
      .Get('api/drivers')
      .withParams({ name: key })
      .send();
    const output = response.results.map((row) => ({
      value: row.id,
      label: row.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getUrlToUpload = async (batchClassification, contentType) => {
  try {
    const response = await operatorClient
      .Get('/api/upload/url-to-upload')
      .withParams({
        batchClassification,
        contentType,
        numberOfFilesToUpload: 1,
      })
      .send();
    return response;
  } catch (e) {
    throw new Error(e);
  }
};

export const uploadDrivers = async (fileName, token) => {
  const results = await authClient
    .Post('/api/file/drivers/upload-batch')
    .withHeaders({ Authorization: `Bearer ${token}` })
    .withData(fileName)
    .send();
  return results;
};

export const generateRefId = async () => {
  try {
    const response = await operatorClient
      .Post('/api/profiles/generate-username')
      .withParams({ namespace })
      .send();
    return response;
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const createAnotherProfile = async (profileId, companyCode, referenceId) => {
  try {
    const response = await operatorClient
      .Post('/api/profiles/v2/new-profile')
      .withData({
        fromProfile: profileId,
        refId: referenceId,
        token: companyCode,
      })
      .send();
  } catch (e) {
    console.error(e);
    throw new Error(e.message);
  }
};
